import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";

import { LoaderCell } from "~/shared/components/trax-grid/loader-cell/loader-cell.tsx";

export type CellWrapper = (
	render: (props: Readonly<GridCustomCellProps>) => JSX.Element,
) => (props: Readonly<GridCustomCellProps>) => JSX.Element;

export const loaderCellWrapper: CellWrapper = () => {
	function LoadingCell(
		props: Readonly<GridCustomCellProps>,
	): React.JSX.Element {
		return <LoaderCell {...props} />;
	}
	return LoadingCell;
};

export const passthroughCellWrapper: CellWrapper = (render) => {
	function PassthroughCell(
		props: Readonly<GridCustomCellProps>,
	): React.JSX.Element {
		return render(props);
	}
	return PassthroughCell;
};
